import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex-1 px-4 text-center first:pl-0 last:pr-0" }
const _hoisted_2 = { class: "text-lg font-bold tabular-nums text-gray-900" }
const _hoisted_3 = {
  key: 0,
  class: "ml-0.5 text-xs font-medium text-gray-400"
}
const _hoisted_4 = { class: "mt-1 text-xs font-medium text-gray-500" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AccumulatedStat',
  props: {
    label: {},
    value: {},
    suffix: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(Number.isFinite(_ctx.value) ? _ctx.$n(Number(_ctx.value.toFixed(1)), 'decimal') : '—'), 1),
      (_ctx.suffix && Number.isFinite(_ctx.value))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.suffix), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.label), 1)
  ]))
}
}

})